module.exports = __webpack_public_path__ + "static/media/troller.fc9fa730.png";